module.exports = __webpack_public_path__ + "pc/img/modal_22.db9a64c6.png";